import { FC } from "react";
import Button from "@mui/material/Button";

interface IProps {
  show: boolean;
  onCheck?: Function;
  syncStatusAdditionalMessage: any;
}

export const SyncStatus: FC<IProps> = ({
  show,
  onCheck,
  syncStatusAdditionalMessage,
}) => {
  if (!show) return null;

  return (
    <div className="sync-status">
      {/* <Loader isLoading> */}
      <div className="sync-status-inner">
        <div className="sync-text">
          Sync continues until this message is closed by “Check status”. Target
          system(s) are now being updated.
        </div>
        {syncStatusAdditionalMessage}
        <Button
          onClick={() => onCheck && onCheck()}
          variant="contained"
          color="success"
        >
          Check Status
        </Button>
      </div>
    </div>
  );
};

export default SyncStatus;
